import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var EventEmitter = /*#__PURE__*/function () {
  /**
   * @classdesc 发布-订阅者模式
   * @constructs EventEmitter
   */
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.events = {};
  }

  /**
   * 绑定事件
   * @method EventEmitter#on
   * @param {String} event 事件名
   * @param {Function} callback 事件回调
   */
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, callback) {
      if (!this.events[event]) {
        this.events[event] = [];
      }
      this.events[event].push(callback);
      return this;
    }

    /**
     * 触发事件
     * @method EventEmitter#emit
     * @param {String} event 事件名
     * @param {Any} [rest] 回调函数的参数，个数不限
     */
  }, {
    key: "emit",
    value: function emit() {
      var _arguments = arguments,
        _this = this;
      var event = Array.prototype.shift.call(arguments);
      this.events[event] && this.events[event].forEach(function (cb) {
        cb.call.apply(cb, [_this].concat(_toConsumableArray(_arguments)));
      });
      return this;
    }

    /**
     * 解绑事件
     * @method EventEmitter#off
     * @param {String} event 事件名
     * @param {Function} [callback] 已绑定的事件回调，如不传则解绑该事件上的所有回调
     */
  }, {
    key: "off",
    value: function off(event, callback) {
      if (this.events[event]) {
        if (!callback) {
          delete this.events[event];
          return;
        }
        var index = this.events[event].findIndex(function (item) {
          return item === callback;
        });
        index >= 0 && this.events[event].splice(index, 1);
      }
      return this;
    }

    /**
     * 绑定一次性事件
     * @method EventEmitter#once
     * @param {String} event 事件名
     * @param {Function} callback 事件回调
     */
  }, {
    key: "once",
    value: function once(event, callback) {
      function temp() {
        callback.apply(this, arguments);
        this.off(event, temp);
      }
      this.on(event, temp);
      return this;
    }
  }]);
  return EventEmitter;
}();
export { EventEmitter as default };